import * as React from 'react';
import tombacIcon from '../tombacIcon';

function SvgCamera(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="2 0 20 24" {...props}>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M14.01 4c.498 0 1.09.341 1.373.782l.064.113L16 6h4c1.048 0 1.914.728 1.994 1.645l.006.139v10.432c0 .934-.816 1.707-1.844 1.779L20 20H4c-1.048 0-1.914-.728-1.994-1.645L2 18.216V7.784c0-.934.816-1.707 1.844-1.779L4 6h4l.554-1.105c.226-.453.794-.832 1.31-.888L9.994 4h4.017zM12 9c-2.208 0-4 1.792-4 4s1.792 4 4 4 4-1.792 4-4-1.792-4-4-4zm.041 1.75a2.25 2.25 0 110 4.5 2.25 2.25 0 010-4.5zM19 8a1 1 0 100 2 1 1 0 000-2z"
      />
    </svg>
  );
}

export default tombacIcon('Camera')(SvgCamera);
